export function AdminEmailLayout (pConfig)
{
  return (
    {
      name : 'EditorToolbarEmailLayoutLocalConfig',

      Groups :
        [
          {
            name : 'HistoryActionsPublic',
            visible : true
          },

          {
            name : 'BlockActionsPublic',
            visible : true
          },

          {
            name : 'TextAlignPublic',
            visible : true
          },

          {
            name : 'FontColorsPublic',
            visible : true
          },

          {
            name : 'TextDecorationPublic',
            visible : true
          },

          {
            name : 'TextDecorationDropdownPublic',
            visible : true,
            isDropdown: true
          },

          {
            name : 'InsertEmailLayoutLocal',
            visible : true
          },

          {
            name : 'BlockStylesEmailLayoutLocal',
            lineBreak : true,
            visible : true
          },

          {
            name : 'MoreEmailLayoutLocalActions',
            visible : true
          },

          {
            name : 'BigSizeButtonsEmailLayoutLocal',
            visible : true
          },
        ]
    });
}